const role = {
  role: 'Role',
  addRole: 'Add Role',
  editRole: 'Edit Role',
};
export default role;
